import flagsmith from '@flagsmith/flagsmith';
import { IS_PRODUCTION } from 'constants/Environment';

let FLAGSMITH_INIT = false;

export function init(config) {
    if (!config) return Promise.resolve();
    const environmentID = IS_PRODUCTION ? 'nfJnJspm2QZ5JHbYv5PuD7' : 'ct9CatBstofNRSwbVQ35bn';

    return new Promise((resolve) => {
        flagsmith
            .init({
                environmentID,
                identity: `${config?.userData?.idUsuario}_${config?.userData?.idImplementacion}`,
                traits: {
                    userId: config.userData.idUsuario,
                    implementation: config.userData.idImplementacion,
                },
                onChange: () => {
                    FLAGSMITH_INIT = true;
                    resolve();
                },
                onError: (e) => {
                    FLAGSMITH_INIT = false;
                    console.error('Flagsmith init error:', e);
                    resolve();
                },
            })
            .catch((e) => {
                // v10: init() now rejects when API is unreachable
                FLAGSMITH_INIT = false;
                console.error('Flagsmith init failed:', e);
                resolve();
            });
    });
}

export function hasFeature(key) {
    if (!FLAGSMITH_INIT) return false;
    return flagsmith.hasFeature(key);
}
